import React from 'react';
import classNames from 'classnames';
import { PlusIcon } from '@icons';

type CommentViewRepliesProps = {
  count: number;
  isExpanded: boolean;
  onClick: () => void;
};

function CommentViewReplies({
  count,
  isExpanded,
  onClick
}: CommentViewRepliesProps) {
  return (
    <div
      className={classNames(
        'comment-view-replies',
        isExpanded && 'is-expanded'
      )}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <PlusIcon className="comment-view-replies-icon" />
      {isExpanded ? `Hide replies (${count})` : `View replies (${count})`}
    </div>
  );
}

export default CommentViewReplies;
